<template>
      <myhead>{{ $route.query.title || $route.meta.title}}</myhead>
      
      <div class="flex between C000  radius15 " style="margin:0 15px;">
            <div>
                  <p class="size18 bold C000 ellipsis_text" >{{ info.name }}</p>
                  <p class="ellipsis_text">出题人:{{ info.questions_setter }}</p>
            </div>
            <div>
                  <p style="text-align:end;color:#578264" v-if="info.status_name == '已通过'">{{ info.status_name }}</p>
                  <p style="text-align:end;color:#f1946f" v-else>{{ info.status_name }}</p>
                  <p >{{ info.add_time }}</p>
            </div>
      </div>
      <div class="marx15">
            <div v-for="item,index  in list " :key="index">
                  <div  v-if="info.question_type == 0" class="flex between mary10">
                        <p class="flex1" >{{ item.name }}</p>
                        <p class="padx5" :style="{'color': item.user_answer == 1 ? '#578264':'#f1946f'}">{{ item.user_answer == 1 ? "接受":"拒绝" }}</p>
                  </div>
                  <div  v-else-if="info.name == '雾森加盟' && [0,1,'0','1'].includes(list[0].answer) && index == 0" class="flex between mary10">
                        <p class="flex1" >{{ item.name }}</p>
                        <p class="padx5" :style="{'color': item.answer == 1 ? '#578264':'#f1946f'}">{{ item.answer == 1 ? "接受":"拒绝" }}</p>
                  </div>
                  <div class="mary10"  v-else>
                        <p class="example mb5">{{ item.name }}</p>
                        <p class="example" style="background-color:#e9e9e9">{{ item.answer }}</p>
                  </div>
            </div>
      </div>

</template>

<script>
import ajax from "@/utils/request.js";
export default {
   data(){
    return{
      info:{},
      list:[]
    }
   },
   created(){
      this.init()
   },
   methods:{
      init(){
            ajax.post("users/answerdetail",{type:this.$route.query.type,id:this.$route.query.id}).then(res=>{
                  this.info = res.data
                  this.list = res.data.question

            })
      },
   }
}
</script>

<style lang="scss" scoped>
.example {
  word-wrap: break-word; /* 允许单词内断行 */
  white-space: normal;   /* 处理空白符，自动换行 */
}
.ellipsis_text{
      width: 50vw;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
}
</style>